/**
 * D3-13b: classifica os campos willUpdatePolicyId/possibleDuplicateIds que a
 * listagem de importacoes (e a resposta do efetivar) trazem. Funcao pura; so
 * ids numericos inteiros positivos sao aceitos, o resto e descartado.
 */
const toId = (value) => (Number.isInteger(value) && value > 0 ? value : null);

export const sanitizeIds = (list) => {
  if (!Array.isArray(list)) return [];
  const ids = [];
  list.forEach((item) => {
    const id = toId(item);
    if (id !== null && !ids.includes(id)) ids.push(id);
  });
  return ids;
};

export const formatIds = (ids) => sanitizeIds(ids).join(", ");

/** { kind: "duplicata", ids } | { kind: "atualiza", policyId } | { kind: "nenhum" } */
export const classifyMatchPreview = (row) => {
  if (!row || typeof row !== "object") return { kind: "nenhum" };
  const ids = sanitizeIds(row.possibleDuplicateIds);
  if (ids.length) return { kind: "duplicata", ids };
  const policyId = toId(row.willUpdatePolicyId);
  if (policyId !== null) return { kind: "atualiza", policyId };
  return { kind: "nenhum" };
};
